export default __webpack_public_path__ + "ffebca889f8b2083e9738113bfa8015b.svg";